import { jsx as _jsx } from "react/jsx-runtime";
import { Stack } from '@mui/material';
import { upperFirst } from 'lodash-es';
export const WidgetTabPanel = ({ active, children, name, }) => {
    return (_jsx(Stack, { "aria-labelledby": `widget-tab-${name}`, id: `widget-tabpanel-${name}`, flexGrow: active ? 1 : 0, role: "tabpanel", hidden: !active, "data-testid": `Widget${upperFirst(name)}`, children: active && children }));
};
